import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ResponsiveNavigation from './components/ResponsiveNavigation';
import MealList from './components/MealList';
import Profile from './components/Profile';
import OrderSummary from './components/OrderSummary';
import Home from './components/Home';
import GamificationDashboard from './components/gamification/GamificationDashboard';
import TakeawayOrder from './components/TakeawayOrder';
import TakeawaySummary from './components/TakeawaySummary';
import Login from './components/Login';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff6b6b',
    },
    secondary: {
      main: '#4ecdc4',
    },
    background: {
      default: '#f7f7f7',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});

function App() {
  return (
    <GoogleOAuthProvider clientId="642033309304-f097g06sq3qf2bbt7c6m0k1o691ceglg.apps.googleusercontent.com">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AuthProvider>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <ResponsiveNavigation />
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  width: '100%',
                  mt: {
                    xs: '56px', // Mobile AppBar height
                    sm: '64px'  // Desktop AppBar height
                  },
                  px: {
                    xs: 2,
                    sm: 3
                  },
                  pt: 3,
                  pb: 4,
                }}
              >
                <Container
                  maxWidth="lg"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    margin: '0 auto'
                  }}
                >
                  <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    
                    {/* Protected routes */}
                    <Route element={<ProtectedRoute />}>
                      <Route path="/" element={<Navigate to="/home" replace />} />
                      <Route path="/home" element={<Home />} />
                      <Route path="/pre-order" element={<MealList />} />
                      <Route path="/summary" element={<OrderSummary />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/game" element={<GamificationDashboard />} />
                      <Route path="/takeaway-order" element={<TakeawayOrder />} />
                      <Route path="/takeaway-summary" element={<TakeawaySummary />} />
                    </Route>
                    
                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/login" replace />} />
                  </Routes>
                </Container>
              </Box>
            </Box>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;